module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T8jgxk/tc-custom/9781439677988.jpg?1741087062878",
      "alt": "This image is the cover for the book Ghostly Tales of Alabama"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghostly Tales of Alabama\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghost stories from America's \"Heart of Dixie\" have never been so creepy, fun, and full of mystery! "), _c('br'), _vm._v(" Welcome to the spooky state of Alabama!   Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. "), _c('br'), _vm._v(" Did you know that every February, a sunken ship rises again on the Tombigbee River? Or that the man peeking out of the Pickens County Courthouse window was wrongfully imprisoned there…150 years ago? Can you believe the sounds of a Civil War horse still echo on the porch of an old house in Suggsville? "), _c('br'), _vm._v(" Pulled right from history, these ghostly tales will change the way you see Alabama and have you sleeping with the light on!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alan Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("ALAN BROWN  teaches English at the University of West Alabama in Livingston, Alabama. Alan has written primarily about southern ghost lore, a passion that has taken him to haunted places throughout the entire Deep South, as well as parts of the Midwest and the Southwest. Alan's wife, Marilyn, accompanies him on these trips and occasionally serves as his \"ghost magnet.\" Her encounters with the spirit world have been incorporated in a number of Alan's books. In 2018, Alan decided to explore another abiding interest of his--mysteries and legends--in books like  Eerie Alabama  and  The Unexplained South . Alan wrote this book with encouragement--and input--from his grandsons, Cade and Owen.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0